<template lang="pug">
    .page.home(ref="home")
        .head.container
            calendar-title.disabled
                .calendar-slot-wrapper(:class="{empty: !live_event}")
                    months-list(:months="months"
                        :activeMonth="activeMonth"
                        :fixedHeaderHeight="fixedHeaderHeight"
                        @updateActiveMonth="activeMonth=$event")
                    .app_btn(@click="$store.commit('openPopup', 'Subscribe'), $store.commit('setPopupContent', {type: 'all'})") {{$t('other.subscribeToUpdates')}}

                    live-premiere(v-if="live_event")
                    img.liveOrbita(v-else src="@/assets/img/orbita.png")
        //mouse-scroll(:fixedHeaderHeight="fixedHeaderHeight")
        go-to-today-btn

        .dates
            .datesContainer
                .date(v-for="d in allCalendarDays"
                    :id="d.CODE"
                    :class="{[d.MONTH_CODE]: 1, empty: d.EVENTS.length === 0, hidden: dayEventsOpening && openedDay.CODE!==d.CODE, active:(dayEventsOpening && openedDay.CODE===d.CODE), watched: true, today: today.indexOf(d.TIMESTAMP) === 0, along: d.EVENTS.length === 1}"
                    @click="openDayEvents(d.CODE, d)")
                    div
                        .day__text-content
                            h3(v-html="getDayFromDate(d.NAME)")
                            h4(v-html="getMonthFromDate(d.NAME)")
                            .name(v-html="getMainEventPreviewTitle(d.EVENTS) || d.DESCRIPTION")
                        img(v-if="d.PICTURE" :src="d.PICTURE")
                    .bottom
                        .count <span>{{d.EVENTS.length}}</span> {{getEventsCountText(d.EVENTS.length)}}
                        .eye(v-if="dayHasNewEvents(d.EVENTS)")
            main-events-of-day(:class="{open: dayEventsOpening}"
                :day="openedDay"
                @close="closeDayEvents"
                @prev="openDayEvents('prev')"
                @next="openDayEvents('next')")
            .app_btn.anchor(v-anchor="'.home'") {{$t('other.up')}}

        parallax-figures_home

        home-fixed-header(:months="months" :activeMonth="activeMonth")
            months-list(:months="months"
                :activeMonth="activeMonth"
                :fixedHeaderHeight="fixedHeaderHeight"
                @updateActiveMonth="activeMonth=$event")


</template>

<script>

    import CalendarTitle from "../components/other/CalendarTitle";
    import LivePremiere from "../components/other/LivePremiere";
    import MonthsList from "../components/elements/MonthsList";
    import ParallaxFigures_home from "../components/other/ParallaxFigures_home";
    import HomeFixedHeader from "../components/app/HomeFixedHeader";
    import MainEventsOfDay from "../components/elements/MainEventsOfDay";
    import MouseScroll from "../components/other/MouseScroll";
    import GoToTodayBtn from "../components/other/GoToTodayBtn";

    export default {
        name: 'Home',
        data: () => ({
            activeMonth: 0,
            fixedHeaderHeight: 0,
            openedDay: {},
            dayEventsOpening: false,
        }),
        computed: {
            live_event(){
                return this.$store.state.live_event;
            },
            isMobileOrPortrait() {
                return this.$store.state.isMobileOrPortrait;
            },
            calendar() {
                return this.$store.state.calendar;
            },
            watchedList() {
                return JSON.parse(this.$cookie.get('watchedList'));
            },
            allCalendarDays() {
                let allDays = [];
                this.calendar.forEach(m => {
                    allDays = [...allDays, ...m.DAYS];
                });
                return allDays;
            },
            months() {
                return this.calendar.map(el => ({MONTH_NAME: el.MONTH_NAME, MONTH_ID: el.MONTH_ID}))
            },
            today() {
                let d = new Date();
                return String(+(new Date(d.getFullYear(), d.getMonth(), d.getDate())));
            }
        },
        methods: {
            openDayEvents(code, day) { // code - либо код лня либо prev / next
                if (code === 'prev' || code === 'next') {
                    let nextDay;
                    let daysWithEvents = this.allCalendarDays.filter(d => d.EVENTS.length);
                    let openedDayIndex = daysWithEvents.findIndex(d => d.CODE === this.openedDay.CODE);
                    if (code === 'prev') {
                        nextDay = daysWithEvents[openedDayIndex - 1]
                    } else if (code === 'next') {
                        nextDay = daysWithEvents[openedDayIndex + 1]
                    }
                    if (!nextDay || !nextDay.EVENTS.length) return;
                    code = nextDay.CODE;
                    day = nextDay;
                }
                if (this.dayEventsOpening && code === this.openedDay.CODE) return; // если кликаем на открытую дату
                let target = document.querySelector('.home .date[id="' + code + '"]');
                if (!target) return; // если нет элемента, который надо открыть
                let mainEventsOfDay = document.querySelector('.mainEventsOfDay');

                let getExtremeDate = (d) => {
                    console.log(window.getComputedStyle(d).getPropertyValue('table-layout'))
                    if (window.getComputedStyle(d).getPropertyValue('table-layout') === 'fixed') {
                        return d
                    } else {
                        if (d.nextElementSibling && d.nextElementSibling.matches('.date')) {
                            return getExtremeDate(d.nextElementSibling)
                        } else {
                            return d;
                        }
                    }
                };
                let extremeDate = getExtremeDate(target); // крайний элемент в строке
                console.log(extremeDate)


                let timeout = 0;
                let changeLine = mainEventsOfDay.previousElementSibling !== extremeDate; // переходим на другую строку
                if (changeLine && this.dayEventsOpening) {
                    this.closeDayEvents();
                    timeout = 500;
                } else if (this.dayEventsOpening) {
                    mainEventsOfDay.classList.add('fade');
                    timeout = 400;
                }
                setTimeout(() => {
                    if (changeLine) {
                        extremeDate.after(mainEventsOfDay)
                    }
                    this.openedDay = day;
                    setTimeout(() => {
                        mainEventsOfDay.style.height = mainEventsOfDay.querySelector('.container').scrollHeight + 'px';
                        mainEventsOfDay.classList.remove('fade');
                        this.dayEventsOpening = true;
                        this.$scrollPageTo(`.mainEventsOfDay`)
                    })
                    /* window.scrollTo({
                         top: target.getBoundingClientRect().top + window.pageYOffset,
                         behavior: "smooth",
                     })*/
                }, timeout)
            },
            closeDayEvents(e) {
                if (!e || !e.target.closest('.date')) {
                    this.dayEventsOpening = false;
                }
            },

            getMainEventPreviewTitle(events) {
                /*  Название главного события на эту дату*/
                let mainEvent = events.find(el => el.EVENT_MAIN === 'yes') || events[0];
                let MainTitle;
                if (!mainEvent) return false;
                if (mainEvent.EVENT_MAIN_PREVIEW_TITLE) {
                    MainTitle = mainEvent.EVENT_MAIN_PREVIEW_TITLE.replace(/\/span>/g, '/span><br>');
                }
                return MainTitle || mainEvent.NAME;
            },
            getDayFromDate(date) {
                let n = date.split(' ')[0];
                return ('' + n).length > 1 ? n : '0' + n;
            },
            getMonthFromDate(date) {
                return date.split(' ')[1]
            },
            getWeakDaysBeforeFirstDate(date) {
                /*  Сколько пустых дней недели надодобаить до первой даты   */
                if (this.isMobileOrPortrait) {
                    return 0;
                }
                let splitedD = date.split('.');
                let [d, m, y] = splitedD;
                return new Date(y, m - 1, d).getDay() - 1
            },
            getEventsCountText(num) {
                /*   Событие с нужным окончанием    */
                let lastNum = String(num).split('').pop();
                if (['1'].includes(lastNum)) return this.$t('home.event1');
                if (['2', '3', '4'].includes(lastNum)) return this.$t('home.event234');
                return this.$t('home.events');
            },
            dayHasNewEvents(events) {
                if (!this.watchedList) return true;
                return events.find(e => {
                    return this.watchedList[e.CODE] && e.TIMESTAMP > +(String(this.watchedList[e.CODE]).slice(0, 10)) || !this.watchedList[e.CODE]
                })
            }
        },
        mounted() {
            setTimeout(() => {
                this.fixedHeaderHeight = document.querySelector('.fixedHeader').offsetHeight;
            }, 500);
        },
        components: {
            GoToTodayBtn,
            MouseScroll,
            MainEventsOfDay, HomeFixedHeader, ParallaxFigures_home, MonthsList, LivePremiere, CalendarTitle
        },
    }
</script>
<style scoped lang="scss">


    .liveOrbita {
        position: absolute;
        z-index: -1;
        right: 0;
        top: 9rem;
        width: to_rem(670px);
    }

    .head {
        display: flex;
        justify-content: space-between;
        max-width: 115rem;
        margin-bottom: 2.6rem;

        .calendarTitle {
            width: 100%;

            a {
                pointer-events: none !important;
            }

            .calendar-slot-wrapper {
                display: flex;
                align-items: flex-end;
                justify-content: flex-start;
                margin-top: -18.3rem;



                .app_btn, .monthsList {
                    /*margin-top: 13.2rem;*/
                    margin-top: to_rem(300px);
                }

                .monthsList {
                    margin-left: .7rem;
                    margin-right: 5rem;
                    width: 23.4rem;
                }
            }
        }

        .right {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
        }

        .livePremiere {
            margin: 7.15rem 0 0 1rem;
            margin-left: auto;
        }

        @include razr1600 {
            .monthsList {
                margin-right: 1rem;
            }

            .calendarTitle {
                .calendar-slot-wrapper {
                    max-width: none;
                }
            }
        }
    }

    .dates {
        position: relative;
        z-index: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: calc(100% + 1.35rem);
        width: 1660px;
        margin: 0 auto;
        padding: 0 20px;

        .datesContainer {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
        }

        .date {
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: calc((1620px - 1.35rem * 7) / 7 - 1px);
            height: calc((1620px - 1.35rem * 7) / 7);
            margin-bottom: 1.6rem;
            padding-top: 0.9rem;
            cursor: pointer;
            transition: .3s;
            margin-right: 1.35rem;


            &:nth-of-type(7n) {
                table-layout: fixed;
            }

            // просто чтоб определить, что элемент крайний справа
            &:before {
                content: '';
                display: block;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                border: 3px solid $light_blue;
                border-radius: 1rem;
                border-bottom-left-radius: 0;
                box-shadow: 0 0 0.75rem rgba($light_blue, 0.5), inset 0 0 0.75rem rgba($light_blue, 0.5);
                pointer-events: none;
            }

            @include razr1620 {
                width: calc((100vw - 40px - 1.35rem * 7) / 7 - 1px);
                height: calc((100vw - 40px - 1.35rem * 7) / 7);
                &:nth-of-type(1n) {
                    table-layout: auto;
                }
                // просто чтоб определить, что элемент крайний справа
                &:nth-of-type(7n) {
                    table-layout: fixed;
                }
            }
            @include razr1536 {
                width: calc((100vw - 40px - 1.35rem * 6) / 6 - 1px);
                height: calc((100vw - 40px - 1.35rem * 6) / 6);
                &:nth-of-type(7n) {
                    table-layout: auto;
                }
                // просто чтоб определить, что элемент крайний справа
                &:nth-of-type(6n) {
                    table-layout: fixed;
                }
            }

            @include razr1280 {
                width: calc((100vw - 40px - 1.35rem * 5) / 5 - 1px);
                height: calc((100vw - 40px - 1.35rem * 5) / 5);
                &:nth-of-type(6n) {
                    table-layout: auto;
                }
                // просто чтоб определить, что элемент крайний справа
                &:nth-of-type(5n) {
                    table-layout: fixed;
                }
            }

            @include razr1024 {
                width: calc((100vw - 40px - 1.35rem * 4) / 4 - 1px);
                height: calc((100vw - 40px - 1.35rem * 4) / 4);
                &:nth-of-type(5n) {
                    table-layout: auto;
                }
                // просто чтоб определить, что элемент крайний справа
                &:nth-of-type(4n) {
                    table-layout: fixed;
                }
            }

            .day__text-content {
                position: relative;
                z-index: 1;
            }

            h3, h4 {
                padding: 0 1rem;
                color: $light_blue;
                text-shadow: 0 0 1rem rgba($light_blue, 0.5);
            }

            h3 {
                font-size: to_rem(58px);
                line-height: 0.85;
            }

            h4 {
                margin-bottom: 0.7rem;
                font-size: to_rem(20px);
            }

            .name {
                max-height: 4.5rem;
                overflow: hidden;
                padding: 0.2rem 0.8rem;
                font-size: 1rem;
                text-shadow: 0 0 1.5rem rgba($light_blue, 0.5);
            }

            img {
                position: absolute;
                z-index: -1;
                pointer-events: none;
                width: 115%;
                left: calc(50% - 115% / 2);
                top: calc(-25%);
            }

            .bottom {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .count {
                position: relative;
                display: flex;
                align-items: flex-end;
                padding: 0.6rem 1.2rem 0.7rem 0.85rem;
                background: $light_blue;
                border-top-right-radius: 1rem;
                font-size: to_rem(20px);
                line-height: 0.6;
                color: $dark_blue;
                box-shadow: 2px -2px 1.2rem -2px rgba($light_blue, 0.5);
                transition: .3s;

                &:before {
                    content: '';
                    display: block;
                    margin-right: 0.5rem;
                    border: 0.45rem solid $dark_blue;
                    border-top-color: transparent;
                    border-right-color: transparent;
                }

                &:after {
                    content: '';
                    display: block;
                    position: absolute;
                    left: 0;
                    right: 0;
                    top: 98%;
                    background: #fff;
                    height: 0;
                    opacity: 0;
                    transition: .3s;
                }

                span {
                    margin-right: 0.4rem;
                    font-size: to_rem(30px);
                }
            }

            .eye {
                width: 2rem;
                height: 1.5rem;
                margin-right: 0.7rem;
                background: url(../assets/img/eye.png) no-repeat center center / contain;
                opacity: 0;
            }

            &.none {
                opacity: 0;
                pointer-events: none;
            }

            &.hidden {
                opacity: 0.25;
            }

            &.empty {
                /*display: none !important;*/
                opacity: 0.25;
                pointer-events: none;

                .bottom {
                    display: none;
                }

                .name {
                    font-size: 2rem;
                }
            }

            &.watched {
                .eye {
                    opacity: 1;
                }
            }

            &.along {
                .count {
                    font-size: 0;
                    background: none;
                    box-shadow: none;

                    &:before {
                        border-left-color: #fff;
                        border-bottom-color: #fff;
                    }

                    span {
                        display: none;
                    }
                }
            }

            &.today {
                position: relative;

                &:before {
                    background: url(../assets/img/date_today_bg.png) no-repeat center center / 100% 100%;
                    border: none;
                    box-shadow: none;
                    z-index: -1;
                }

                h3, h4 {
                    color: #fff;
                }
            }

            &.active {
                .count {
                    background: #fff;

                    &:after {
                        opacity: 1;
                        height: 0.5rem;
                    }
                }

                &.along .count:before {
                    border-left-color: #000;
                    border-bottom-color: #000;
                }
            }
        }

        .anchor {
            margin: 4rem 0 8rem;
        }
    }

    @include razr1536 {
        .dates .date .name {
            max-height: 5rem;
        }
    }

    @include razr1280 {
        .dates .date .name {
            max-height: 5.5rem;
        }
    }

    @include razr1200 {
        .head {
            .livePremiere {
                margin-top: 1rem;
                margin-bottom: 0;
                margin-left: 0;
            }

            .calendarTitle {
                .calendar-slot-wrapper {
                    margin-top: 0;



                    flex-direction: column;
                    align-items: flex-start;

                    .monthsList {
                        margin-top: 1rem;
                    }

                    .app_btn {
                        margin-top: 0;
                    }
                }
            }
        }
    }

    @include mobile_or_P {
        .liveOrbita{
            display: none;
        }
        .head {
            flex-direction: column;
            margin-bottom: 2.4rem;
            padding-right: 1rem;

            .right {
                align-items: center;
            }

            .calendarTitle {
                .calendar-slot-wrapper {
                    .monthsList {
                        order: 3;
                        margin: 1rem 0 0;
                        width: 100%;
                    }

                    .app_btn {
                        order: 1;
                        margin-left: 7rem;
                    }

                    .livePremiere {
                        order: 2;
                        margin-left: -1rem;
                    }
                }
            }

            .livePremiere {
                margin: 2.9rem 0 2.7rem 0;
                /*flex-wrap: wrap;*/
            }

            .monthsList {
                margin-right: 0;
            }
        }
        .dates {
            max-width: 100%;
            padding: 0 0 0 1.4rem;

            .date {
                width: calc((100vw - 1.4rem - 1.5rem * 2) / 2 - 1px);
                height: calc((100vw - 1.4rem - 1.5rem * 2) / 2);
                margin-right: 1.5rem;

                &:nth-of-type(6n) {
                    table-layout: auto;
                }

                // просто чтоб определить, что элемент крайний справа
                &:nth-of-type(2n) {
                    table-layout: fixed;
                }

                h3, h4 {
                    padding: 0 0.9rem;
                }

                h3 {
                    font-size: 3.6rem;
                }

                h4 {

                    margin-bottom: 0;
                    font-size: 1.3rem;
                }

                .name {
                    max-height: 4.3rem;
                }
            }
        }
    }

    .thumb-wrap {
        position: relative;
        padding-bottom: 56.25%; /* задаёт высоту контейнера для 16:9 (если 4:3 — поставьте 75%) */
        height: 0;
        overflow: hidden;
    }

    .thumb-wrap iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-width: 0;
        outline-width: 0;
    }
</style>
